import React, { useEffect, useState } from "react"
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"
import { setDomainBrand, getBrandName, getDomainBrand, resetDomainBrand } from "../Branding"

const brands = ["general", "workforce", "gaming"]

export const SetBrand = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [curVal, setCurVal] = useState(getDomainBrand())

  const toggle = () => setDropdownOpen(prev => !prev)

  const handleSelect = (item) => {
    setDomainBrand(item)
    setDropdownOpen(true)
    setCurVal(item)
    window.location.reload()
  }

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret>
        {curVal || "Select an option"}
      </DropdownToggle>
      <DropdownMenu>
        {brands.map((item, idx) => (
          <DropdownItem key={idx} onClick={() => handleSelect(item)}>
            {item}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  )
}
